import { AnnotationStatus } from "@models/annotation-status.enum";
import { createSelector } from "@ngrx/store";
import { AppState } from "@store/app.state";
import { range } from "lodash";
import { LifeCycleEdit } from "src/app/components/review/redaction-annotation/life-cycle-edit.enum";

const selectFeature = (state: AppState) => state.docViewer?.annotationEditor;

export const currentAnnotationEditor = createSelector(
    selectFeature,
    (state) => {
        return state;
    }
);

export const currentAnnotationId = createSelector(
    selectFeature,
    (state) => {
        return state?.currentAnnotationId;
    }
);

export const currentAnnotationStatus = createSelector(
    selectFeature,
    (state) => {
        return state?.status;
    }
);

export const allAnnotations = createSelector(
    selectFeature,
    (state) => {
        return state?.annotations;
    }
);

export const currentActiveAnnotations = createSelector(
    selectFeature,
    (state) => {
        return state?.annotations.filter(e => e.status != LifeCycleEdit.Deleted);
    }
);

export const maxAnnotationId = createSelector(
    allAnnotations,
    (annotations) => {
        const maxClientId = annotations.reduce((max, annotation) => {
            return Math.max(max, annotation.clientId);
        }, 0);
        return maxClientId;
    }
);

export const currentAnnotationEditorPage = createSelector(
    selectFeature,
    (state) => {
        return state.pageNumber;
    }
);

export const currentDocTotalPageCount = createSelector(
    selectFeature,
    (state) => {
        return state.totalPages;
    }
);

export const currentColors = createSelector(
    selectFeature,
    (state) => {
        return state.colors;
    }
);

export const currentFileId = createSelector(
    selectFeature,
    (state) => {
        return state.fileIdList[state.pageNumber];
    }
);

export const annotationsForCurrentPage = createSelector(
    currentActiveAnnotations, currentAnnotationEditorPage,
    (annotations, pageNumber) => {
        return annotations.filter(x => x.rank === pageNumber)
    }
);

export const pagesAsAnArray = createSelector(
    currentDocTotalPageCount,
    (totalPages) => {
        return range(1, totalPages + 1);
    }
);

export const isAnnotationEditorProcessing = createSelector(
    currentAnnotationStatus,
    (status) => {
        if ((status & AnnotationStatus.ImagesCreationRequested)
            || (status & AnnotationStatus.ImagesProcessing)
            || (status & AnnotationStatus.PdfCreationRequested)
            || (status & AnnotationStatus.PdfProcessing)) {
            return true;
        }
        return false;
    }
);

export const annotationEditorMode = createSelector(
    currentAnnotationStatus, isAnnotationEditorProcessing,
    (status, isProcessing) => {
        if (status === AnnotationStatus.None) {
            return 'generate-images';
        } else if (isProcessing) {
            return 'loading';
        } else if ((status & AnnotationStatus.HasImages) || (status & AnnotationStatus.HasPdf)) {
            return 'annotate-images';
        }
        return 'loading';
    }
);

export const docHasAnnotationImages = createSelector(
    currentAnnotationStatus,
    (status) => {
        if ((status & AnnotationStatus.HasImages) || (status & AnnotationStatus.HasPdf)) {
            return true;
        }
        return false;
    }
);

export const isManualAnnotation = createSelector(
    currentAnnotationStatus,
    (status) => status === AnnotationStatus.HasPdf);

